// components/CategoryToggleButton.jsx
import React from 'react';

function CategoryToggleButton({ showSidebar, toggleSidebar }) {
  return (
    <div
      className={`text-nowrap d-lg-none text_master2 cursor-pointer ms-3 ms-lg-0 ${
        showSidebar ? 'd-none' : ''
      }`}
      onClick={toggleSidebar}
    >
      {showSidebar ? 'Close Category' : 'Show Category'}
    </div>
  );
}

export default CategoryToggleButton;
